import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { Patient } from '../../../../api/models'
const CURRENT_PATIENT = 'currentPatient'

@Injectable({
  providedIn: 'root',
})
export class SelectedPatientService {
  currentPatient = new BehaviorSubject<Patient>(
    JSON.parse(sessionStorage.getItem(CURRENT_PATIENT)),
  )

  changePatient(patient) {
    sessionStorage.setItem(CURRENT_PATIENT, JSON.stringify(patient))
    this.currentPatient.next(patient)
  }

  getPatient(): Observable<Patient> {
    return this.currentPatient.asObservable()
  }

  getPatientValue() {
    return this.currentPatient.value
  }
}
